import styles from './CancelOptions.module.scss';
import OptionCard from '../OptionCard/OptionCard';
import CalendarClock from '../../../../src/images/calendar-clock.svg';
import HistoryClock from '../../../../src/images/history-clock.svg';

const CancelOptions = ({
  onClickHandler = () => {},
  toggleCancel = () => {},
}) => {
  const enterKeyHandler = (e) => {
    if (e.key == 'Enter') {
      onClickHandler('cancel');
      toggleCancel(false);
    }
  };
  return (
    <div className={styles.cancelOptionsWrapper}>
      <h4 className={styles.beforeYouCancel}>
        Before you cancel, have you tried...
      </h4>

      <div className={styles.cancelOptionsContainer}>
        <div className={styles.cancelOptionsCards}>
          <OptionCard
            icon={<CalendarClock />}
            btnText="Delay Order"
            title="Delay My Order"
            description="Still have Relief Factor left? You can delay your next shipment by scheduling your next shipping date."
            onClickHandler={() => {
              onClickHandler('date');
              toggleCancel(false);
            }}
          />

          <OptionCard
            icon={<HistoryClock />}
            btnText="Change Frequency"
            title="Change My Frequency"
            description="Is your Relief Factor piling up? You can change your frequency to fit your needs."
            onClickHandler={() => {
              onClickHandler('frequency');
              toggleCancel(false);
            }}
          />
        </div>
        <a
          className={styles.newCancelBtn}
          onClick={() => {
            onClickHandler('cancel');
            toggleCancel(false);
          }}
          onKeyDown={(event) => enterKeyHandler(event)}
          tabIndex={0}
        >
          Pause or cancel my subscription
        </a>
      </div>
    </div>
  );
};

export default CancelOptions;
